<template>
  <div
    id="app"
    class="flex flex-col min-h-screen"
    :class="{ 'border-none': $route.path === '/login' }"
  >
    <Navbar v-if="showNavbar" @toggleMenu="isMenuOpen = !isMenuOpen" />
    <div :class="{ 'mt-16 ml-4 mr-4': showNavbar, 'mt-0': !showNavbar }">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/NavbarComp.vue";
export default {
  components: {
    Navbar,
  },
  data() {
    return {
      showNavbar: true,
      isMenuOpen: false,
    };
  },
  watch: {
    $route(to) {
      if (to.path === "/login") {
        this.showNavbar = false;
      } else {
        this.showNavbar = true;
      }
    },
  },
};
</script>
